import { GET_METAMASK } from "../types";

export const metamask = () => {
    return {
        type: GET_METAMASK,
    };
};